<template>
  <v-container grid-list-xl>
    <DateFilter @date:changed="refreshAnalytics" />
    <v-layout row wrap>

      <v-flex xs12>
        <v-card>
          <v-card-title
            class="subheading font-weight-bold px-4"
          >Interventions History</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <BarChart v-if="countryAnalytics !== null" :values="countryAnalytics.history.values" :labels="countryAnalytics.history.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions Overview by States</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <PieChart v-if="countryAnalytics !== null" :values="countryAnalytics.overview.values" :labels="countryAnalytics.overview.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions Overview by Agency</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <PieChart v-if="countryAnalytics !== null" :values="countryAnalytics.overview_agency.values" :labels="countryAnalytics.overview_agency.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BarChart from '@/components/Charts/BarChart.vue'
import PieChart from '@/components/Charts/PieChart.vue'
import DateFilter from '@/components/Filters/DateFilter.vue'
import { setFormData } from '@/utils/http'
import { refineAnalytics } from '@/utils/analytics'

export default {
  name: 'AdminDashboard',
  components: {
    BarChart,
    PieChart,
    DateFilter
  },
  data () {
    return {
      analyticsLoading: false,
      countryAnalytics: null
    }
  },
  methods: {
    fetchAdminAnalytics (from, to, period) {
      this.analyticsLoading = true
      this.countryAnalytics = null
      const params = setFormData({
        country_id: this.$settings.country,
        from_timestamp: from,
        to_timestamp: to,
        period: period
      })
      this.$http.post('aid/analytics_by_country', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            this.analyticsLoading = false
            // Country Analytics
            this.countryAnalytics = refineAnalytics('nema', response.data)
          }
        })
    },
    refreshAnalytics (payload) {
      this.fetchAdminAnalytics(payload.from, payload.to, payload.period)
    }
  }
}
</script>
